import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Layout, Menu, Breadcrumb, Icon, Affix, Switch } from 'antd';
import { login, logout, isLoggedIn } from 'utils/AuthService';
import MediaQuery from 'react-responsive';
import { translate  } from 'react-i18next';
import _ from 'lodash';

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;


class Sidebar extends Component {

    constructor(props) {
        super(props);
    }
    state = {
        collapsed: this.props.collapsed,
        goalId: this.props.goalId
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ goalId: nextProps.goalId, collapsed: nextProps.collapsed });
    }

    render() {
        return (
            <div>
              <MediaQuery query="(max-width: 768px)">
                <Affix offsetTop={50} style={{ position: 'absolute', top: 50, left: 0, zIndex: 1000}}>
                  <Sider
                  collapsible
                  trigger={null}
                  collapsed={this.state.collapsed}
                  onCollapse={this.onCollapse.bind(this)}
                  collapsedWidth="0">
                    {this.renderContents()}
                  </Sider>
                </Affix>
              </MediaQuery>
              <MediaQuery query="(min-width: 768px)">
                <Affix>
                  <Sider
                  collapsed={false}
                  collapsedWidth="0"
                  onCollapse={this.onCollapse.bind(this)}>
                    {this.renderContents()}
                  </Sider>
                </Affix>
              </MediaQuery>
            </div>
        );
    }


    renderContents() {
        const {t} = this.props;
        const goalId = this.state.goalId;
        const role = _.get(this.props.user, 'role');

        return (
              <div className="left-bar">
                <div className="logo">
                <MediaQuery query="(min-width: 768px)">
                  <img src={`${process.env.PUBLIC_URL}/logo.png`} width="100%"/>
                </MediaQuery>
                </div>
                <Menu theme="dark" defaultSelectedKeys={['video']} mode="inline" onClick={this.onMenuClick.bind(this)}>
                  {(goalId)
                  ? 
                  <Menu.Item key="dashboard">
                    <Link to={`/`}>
                    <Icon type="dashboard" />
                    <span>Dashboard</span></Link>
                  </Menu.Item>
                  : 
                  <Menu.Item key="start">
                    <Link to={`/goals`}>
                    <Icon type="right" />
                    <span>Start</span></Link>
                  </Menu.Item>
                   }
                  {(goalId && role!="test") ? 
                    this.renderForecastMenu(goalId)
                     : ""}
                  {(goalId && role!="test") ?
                  <Menu.Item key="assumptions">
                    <Icon type="usergroup-add" />
                    <span><Link to={`/assumptions/${goalId}`}>{t('sidebar.menu.fundamentalAssumptions')}</Link></span>
                  </Menu.Item>
                  : "" }
                  {(goalId && role!="test") ? 
                  <Menu.Item key="journeys">
                    <Icon type="car" />
                    <span><Link to={`/journeys/${goalId}`}>{t('sidebar.menu.buyersJourney')}</Link></span>
                  </Menu.Item>
                  : "" }
                </Menu>
              </div>
        );
    }

    renderForecastMenu(goalId) {
        const {t} = this.props;
        return <SubMenu
              key="forecast"
              title={<span><Icon type="cloud" /><span>{this.props.t('sidebar.menu.forecast')}</span></span>}
            >
              <Menu.Item key="forecast-focus1"><Link to={`/forecast/impressions/${goalId}`}>{t('sidebar.forecast.impressions')}</Link></Menu.Item>
              <Menu.Item key="forecast-focus2"><Link to={`/forecast/traffic/${goalId}`}>{t('sidebar.forecast.traffic')}</Link></Menu.Item>
              <Menu.Item key="forecast-focus6"><Link to={`/forecast/visitors/${goalId}`}>{t('sidebar.forecast.visitors')}</Link></Menu.Item>
              <Menu.Item key="forecast-focus3"><Link to={`/forecast/optin/${goalId}`}>{t('sidebar.forecast.optin')}</Link></Menu.Item>
              <Menu.Item key="forecast-focus4"><Link to={`/forecast/closerate/${goalId}`}>{t('sidebar.forecast.closeRate')}</Link></Menu.Item>
              <Menu.Item key="forecast-focus5"><Link to={`/revenue/${goalId}`}>{t('sidebar.forecast.revenue')}</Link></Menu.Item>
            </SubMenu>

    }

    onMenuClick = () => {
        this.props.onMenuClick(true);
    }

    onCollapse = () => {
        //this.setState({ collapsed: !this.state.collapsed });
    }

}

export default translate('translations')(withRouter(Sidebar));


// WEBPACK FOOTER //
// ./src/components/layouts/Sidebar.js